import type { Ref } from "vue"
import { fetchLanguages } from "@/app/api"
import { api } from "@/services"
import { ref } from "vue"

interface Locale {
  code: string
  name: string
  friendly_name: string
}

const locales: Ref<Locale[]> = ref([])
const locale: Ref<Locale> = ref()
export const t = useI18n().t
let messages

export function useI18n() {
  async function initI18n() {
    messages = []

    if (locales.value.length === 0) {
      await loadLanguages()
    }

    const osLang = window.navigator.language.substring(0, 2)
    const lang
      = localStorage.getItem(`${import.meta.env.VITE_APP_NAME}_lang`)
        ?? (osLang || import.meta.env.VITE_APP_DEFAULT_LOCALE)
    await loadLanguage(lang)
  }

  async function loadLanguages() {
    try {
      const response = await fetchLanguages()
      locales.value = response.data.data || []
    }
    catch (error) {
      console.error("Failed to load languages from API:", error)
      locales.value = [
        { code: "en", name: "English", friendly_name: "English" },
      ]
    }
  }

  async function loadLanguage(lang) {
    if (locale.value?.code !== lang) {
      const localeMessages = await api.utils.downloadLanguage(lang)
      messages[lang] = localeMessages[lang]
      locale.value = locales.value.find(l => l.code === lang) || locales.value[0]
      localStorage.setItem(`${import.meta.env.VITE_APP_NAME}_lang`, lang)
    }
  }

  function t(msg, params = null) {
    if (!msg || !locale.value) {
      return ""
    }
    let val
      = msg.split(".").reduce((val, part) => {
        return val?.[part] ?? null
      }, messages[locale.value.code]) ?? msg
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        val = val.replace(`{${key}}`, value)
      }
    }
    return val ?? msg
  }

  return {
    t,
    locale,
    locales,
    initI18n,
    loadLanguage,
    loadLanguages,
  }
}
